import {FC} from 'react'

const ProjectDetailSkeleton: FC = () => {
  return (
    <div className='d-flex flex-column flex-column-fluid'>
      {/* Header Skeleton */}
      <div className='toolbar' id='kt_toolbar'>
        <div id='kt_toolbar_container' className='container-fluid d-flex flex-stack'>
          <div className='page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0'>
            <div className='placeholder placeholder-lg bg-light w-40px h-40px rounded me-3'></div>
            <div>
              <div className='placeholder placeholder-lg bg-light w-200px mb-2'></div>
              <div className='placeholder placeholder-sm bg-light w-300px'></div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div id='kt_content' className='content flex-column-fluid'>
        <div className='container-xxl'>
          {/* Stats Cards Skeleton */}
          <div className='row g-5 g-xl-8 mb-5'>
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className='col-xl-3 col-lg-6 col-md-6'>
                <div className='card card-xl-stretch mb-xl-8'>
                  <div className='card-body d-flex flex-column p-6'>
                    <div className='d-flex align-items-center mb-4'>
                      <div className='symbol symbol-50px me-3'>
                        <div className='symbol-label bg-light-primary placeholder-wave'></div>
                      </div>
                      <div>
                        <div className='placeholder placeholder-lg bg-light w-50px mb-2'></div>
                        <div className='placeholder placeholder-sm bg-light w-80px'></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Project Info Skeleton */}
          <div className='card mb-5'>
            <div className='card-body'>
              <div className='d-flex align-items-center justify-content-between mb-4'>
                <div className='d-flex align-items-center'>
                  <div className='symbol symbol-60px me-4'>
                    <div className='symbol-label bg-light-primary placeholder-wave'></div>
                  </div>
                  <div>
                    <div className='placeholder placeholder-lg bg-light w-250px mb-2'></div>
                    <div className='placeholder placeholder-lg bg-light w-400px mb-2'></div>
                    <div className='d-flex align-items-center gap-3'>
                      <div className='placeholder placeholder-lg bg-light w-60px h-25px rounded'></div>
                      <div className='placeholder placeholder-sm bg-light w-150px'></div>
                    </div>
                  </div>
                </div>
                <div className='d-flex align-items-center gap-2'>
                  <div className='placeholder placeholder-lg bg-light w-70px h-25px rounded'></div>
                  <div className='placeholder placeholder-lg bg-light w-80px h-25px rounded'></div>
                  <div className='placeholder placeholder-lg bg-light w-90px h-25px rounded'></div>
                </div>
              </div>
            </div>
          </div>

          {/* Categories Section Skeleton */}
          <div className='card mb-5'>
            <div className='card-header border-0 pt-6'>
              <div className='card-title'>
                <div className='placeholder placeholder-lg bg-light w-120px'></div>
              </div>
              <div className='card-toolbar'>
                <div className='placeholder placeholder-lg bg-light w-130px h-40px rounded'></div>
              </div>
            </div>
            <div className='card-body pt-0'>
              <div className='table-responsive'>
                <table className='table align-middle table-row-dashed fs-6 gy-5'>
                  <thead>
                    <tr>
                      <th><div className='placeholder placeholder-sm bg-light w-60px'></div></th>
                      <th><div className='placeholder placeholder-sm bg-light w-100px'></div></th>
                      <th><div className='placeholder placeholder-sm bg-light w-60px'></div></th>
                      <th><div className='placeholder placeholder-sm bg-light w-70px'></div></th>
                    </tr>
                  </thead>
                  <tbody>
                    {[1, 2, 3].map((row) => (
                      <tr key={row}>
                        <td><div className='placeholder placeholder-sm bg-light w-120px'></div></td>
                        <td><div className='placeholder placeholder-sm bg-light w-200px'></div></td>
                        <td><div className='placeholder placeholder-sm bg-light w-60px h-20px rounded'></div></td>
                        <td>
                          <div className='d-flex gap-2 justify-content-end'>
                            <div className='placeholder placeholder-sm bg-light w-30px h-30px rounded'></div>
                            <div className='placeholder placeholder-sm bg-light w-30px h-30px rounded'></div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* URLs Section Skeleton */}
          <div className='card'>
            <div className='card-header border-0 pt-6'>
              <div className='card-title'>
                <div className='placeholder placeholder-lg bg-light w-150px'></div>
              </div>
              <div className='card-toolbar'>
                <div className='placeholder placeholder-lg bg-light w-100px h-40px rounded'></div>
              </div>
            </div>
            <div className='card-body pt-0'>
              <div className='table-responsive'>
                <table className='table align-middle table-row-dashed fs-6 gy-5'>
                  <thead>
                    <tr>
                      <th><div className='placeholder placeholder-sm bg-light w-80px'></div></th>
                      <th><div className='placeholder placeholder-sm bg-light w-100px'></div></th>
                      <th><div className='placeholder placeholder-sm bg-light w-150px'></div></th>
                      <th><div className='placeholder placeholder-sm bg-light w-80px'></div></th>
                    </tr>
                  </thead>
                  <tbody>
                    {[1, 2, 3, 4].map((row) => (
                      <tr key={row}>
                        <td><div className='placeholder placeholder-sm bg-light w-150px'></div></td>
                        <td><div className='placeholder placeholder-sm bg-light w-120px'></div></td>
                        <td><div className='placeholder placeholder-sm bg-light w-200px'></div></td>
                        <td><div className='placeholder placeholder-sm bg-light w-60px h-20px rounded'></div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ProjectDetailSkeleton}

